import { defineRule } from 'vee-validate'
import useGlobalHelpers from '@/mixins/useGlobalHelpers.js'
import store from '../store'
import i18n from '../i18n'

export default {
  install: () => {
    defineRule('required', (value) => {
      if (!value || !value.length) {
        return i18n.global.t('rules.required')
      }
      return true
    })
    defineRule('dollar', (value) => {
      // Field is empty, should pass
      if (!value || !value.length) {
        return true
      }
      // Check if email
      if (!/^(?!0+,00)(?=.{1,9}(\.|$))(?!0(?!,))\d{1,3}(,\d{3})*(.\d{2})?$/.test(value)) {
        return i18n.global.t('rules.dollar')
      }
      return true
    })

    defineRule('birthdate', (value) => {
      // Field is empty, should pass
      if (!value || !value.length) {
        return true
      }
      // Check if birthdate $"#%"!$!"%
      if (!/(^(0[1-9]|[12][0-9]|3[01]) \/ (0[1-9]|1[012]) \/ \d{4}$)/.test(value)) {
        return i18n.global.t('rules.dollar')
      }
      return true
    })

    defineRule('alphabet', (value) => {
      // Check if email
      if (!/^[A-zÀ-ú\s]+$/.test(value)) {
        return i18n.global.t('rules.alphabet')
      }
      return true
    })

    defineRule('address', (value) => {
      // Check if email
      if (!/^[[A-zÀ-ú0-9\s,.\-\\p{L}'/°º⁰]*$]*$/.test(value)) {
        return i18n.global.t('rules.alphabet')
      }
      return true
    })

    defineRule('zip', (value) => {
      // Check if email
      if (!/^[A-z0-9\s-]*$/.test(value)) {
        return i18n.global.t('rules.alphabet')
      }
      return true
    })

    defineRule('email', (value) => {
      // Field is empty, should pass
      if (!value || !value.length) {
        return true
      }
      // Check if email
      if (!/^[A-Za-z0-9!$#_'\/|+\-.?]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)+$/.test(value)) {
        return i18n.global.t('rules.email')
      }
      return true
    })

    defineRule('vopayAddress', (value) => {
      if (!value || !value.length) return true
      return /^[A-Za-z0-9,:'_()\/.\- ]+$/.test(value) || i18n.global.t('rules.vopay')
    })

    defineRule('vopayCity', (value) => {
      if (!value || !value.length) return true
      return /^[A-Za-z0-9:'.\- ]+$/.test(value) || i18n.global.t('rules.vopay')
    })

    defineRule('vopayNames', (value) => {
      if (!value || !value.length) return true
      return /^[A-Za-z0-9,$'()\/.&*\- ]+$/.test(value) || i18n.global.t('rules.vopay')
    })
   
    defineRule('website', (value) => {
      // Field is empty, should pass
      if (!value || !value.length) {
        return true
      }

      value = 'https://www.' + value

      // Check if website
      if (!/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi.test(value)) {
        return i18n.global.t('rules.website')
      }
      return true
    })

    defineRule('maxLength', (value, args) => {
      // Check if email
      if (value?.length > args[0]) {
        return i18n.global.t('rules.max_length', {maxLength: args[0]}, args[0])
      }
      return true
    })    
    
    defineRule('exactLength', (value, args) => {
      // Check if email
      if (value.length != args[0]) {
        return i18n.global.t('rules.exact_length', {exactLength: args[0]}, args[0])
      }
      return true
    })

    defineRule('newPw', (value, args) => {
      if (value === args[0]) {
        return i18n.global.t('rules.password')
      }
      return true
    })

    defineRule('minLength', (value, args) => {
      if (value?.length < args[0]) {
        return i18n.global.t('rules.min_length', {minLength: args[0]}, args[0])
      }
      return true
    })

    defineRule('hasUpperLower', (value) => {
      if (!/(?=.*[a-z])(?=.*[A-Z])/.test(value)) {
        return i18n.global.t('rules.cases')
      }
      return true
    })


    defineRule('hasNumberSymbol', (value) => {
      if (
        !/(?=.*\d)(?=.*[!\\"#$%&/()=?\\_\\-\\@\\^\\+\\'\\»\\«\\,\\.\\>\\<\\£\\§\\€\\`\\´\\~\\*])/.test(
          value
        )
      ) {
        return i18n.global.t('rules.number_symbol')
      }
      return true
    })

    defineRule('minProposal', (value, args) => {
      const { dollarFormatting } = useGlobalHelpers()

      if (value) {
        let val = value
        if (typeof val === 'string') {
          val = val.replaceAll(',', '')
          if (val.includes('.')) {
            val = parseFloat(val.replaceAll('.', ''))
          } else {
            val = parseFloat(val) * 100
          }
        }

        if (val < parseInt(args[0])) {
          let invalidValue = parseInt(args[0])
          return i18n.global.t(
            'rules.min_proposal_value',
            { invalidValue: dollarFormatting(invalidValue) },
            invalidValue
          )
        }

        return true
      }
    })

    defineRule('maxProposal', (value, args) => {
      const { dollarFormatting } = useGlobalHelpers()

      if (value) {
        let val = value
        if (typeof val === 'string') {
          val = val.replaceAll('.', '')
          if (val.includes(',')) {
            val = parseFloat(val.replaceAll(',', ''))
          } else {
            val = parseFloat(val) * 100
          }
        }

        if (val > parseInt(args[0])) {
          let invalidValue = parseInt(args[0])
          return i18n.global.t(
            'rules.max_proposal_value',
            { invalidValue: dollarFormatting(invalidValue) },
            invalidValue
          )
        }

        return true
      }
    })

    defineRule('min', (value, args) => {
      if (value) {
        let invalidValue = args[0]

        if (value < parseInt(args[0])) {
          return i18n.global.t('rules.min_value', { invalidValue }, invalidValue)
        }

        return true
      }
    })

    defineRule('max', (value, args) => {
      if (value) {
        let invalidValue = args[0]

        if (value > parseInt(args[0])) {
          return i18n.global.t('rules.max_value_general', { invalidValue }, invalidValue)
        }

        return true
      }
    })

    defineRule('minValue', (value, args) => {
      value = value.toString()
      const { dollarFormatting } = useGlobalHelpers()
      if(value) {
        let val = value.replaceAll(',', '')
        let invalidValue = args[0]
        let isDollar = args[1] ?? 1

        if (parseInt(isDollar)) {
          val = parseFloat(val) * 100
          invalidValue = '$' + dollarFormatting(parseFloat(args[0]))
        }
  
        if (val < parseInt(args[0])) {
          return i18n.global.t('rules.min_value', {invalidValue}, invalidValue)
        }
  
        return true
      }
    })

    defineRule('maxValue', (value, args) => {
      const { dollarFormatting } = useGlobalHelpers()
      if (value) {
        let val = value.replaceAll(',', '')
        let invalidValue = args[0]
        let isDollar = args[1] ?? 1
  
        if (parseInt(isDollar)) {
          val = parseFloat(val) * 100
          invalidValue = '$' + dollarFormatting(parseFloat(args[0]))
        }
    
        if (val > parseInt(args[0])) {
          return i18n.global.t('rules.max_value', {invalidValue}, invalidValue)
        }
  
        return true
      }
    })

    defineRule('multiplier', (value, args) => {
      const { dollarFormatting } = useGlobalHelpers()

      if (value) {
        let val = value.replaceAll(',', '')
        let multiplier = args[0]
        let isDollar = args[1] ?? 1

        if (parseInt(isDollar)) {
          val = parseFloat(val) * 100
          multiplier = '$' + dollarFormatting(parseFloat(multiplier))
        }
    
        if (val % parseInt(args[0])) {
          return i18n.global.t('rules.multiplier', {multiplier}, multiplier)
        }
  
        return true
      }
    })

     //Only allow numbers and letters with no spaces
     defineRule('alphaNumeric', (value) => {
      const pattern = /^[a-zA-Z0-9]*$/
      const isValid = pattern.test(value)
      if (!isValid) {
        return i18n.global.t('rules.alpha_numeric_only')
      }
      return true
    })

     //Only allow numbers
     defineRule('numeric', (value) => {
      const pattern = /^[0-9]*$/
      const isValid = pattern.test(value)
      if (!isValid) {
        return i18n.global.t('rules.numeric_only')
      }
      return true
    })
  }
}
